import styles from './intro-section.module.css'
import { StoryblokRenderer } from '../../../storyblok-renderer/storyblok-renderer'
import { SbBlokData } from '@storyblok/react'
import { landingStoryblokComponents } from '../../storyblok-renderer-map'

export type IntroSectionProps = {
  content: SbBlokData[]
}

export const IntroSection: React.FC<IntroSectionProps> = ({ content }) => (
  <div className={styles.intro}>
    <StoryblokRenderer
      block={content}
      components={landingStoryblokComponents}
    />
  </div>
)
